angular.module('natgeo').controller('Level5SplashScreen', ['$scope', '$element', 'ScreenFactory', 'screenManager', 'container', 'SoundEngine', 'Analytics',
function Level5SplashScreen($scope, element, ScreenFactory, manager, container, SoundEngine, Analytics)
{
	var screen = ScreenFactory( 'level5_splash', element );
	
	screen.once('introBefore', function()
	{
		anim8.save('level5SplashOverlay', {
			keyframe: {
				from: {
					opacity: 0,
					scale: 1,
					translateY: 0
				},
				to: {
					opacity: 1,
					scale: 1.2,
					translateY: -5
				}
			},
			units: {
				translateY: '%'
			}
		});

		anim8.save('splashFadeInHalf', {
			keyframe: {
				from: {
					opacity: 0
				},
				to: {
					opacity: 0.5
				}
			}
		});

		anim8.save('splashFadeOutHalf', {
			keyframe: {
				from: {
					opacity: 0.5
				},
				to: {
					opacity: 0
				}
			}
		});

		anim8.save('level4SplashArtifact1', {
			keyframe: {
				'0': {
					opacity: 0,
					scale: 0,
					translate: { 
						x: +(1024 / 2) / 147 * 100 - 147 * 0.3,
						y: -(420 / 2) / 75 * 100
					} 
				},
				'40': {
					opacity: 1
				},
				'90': {
					opacity: 1,
					translate: 0
				},
				'100': {
					opacity: 0,
					scale: 1,
					translate: {
						x: -(1024 / 2) / 147 * 10,
						y: +(420 / 2) / 75 * 10
					}
				}
			},
			units: {
				translate: '%'
			}
		}, {
			easing: 'linear'
		});

		anim8.save('level4SplashArtifact2', {
			keyframe: {
				'0': {
					opacity: 0,
					scale: 0,
					translate: { 
						x: -(1024 / 2) / 129 * 100 + 20,
						y: -(420 / 2) / 189 * 100 + 20
					} 
				},
				'40': {
					opacity: 1
				},
				'90': {
					opacity: 1,
					translate: 0
				},
				'100': {
					opacity: 0,
					scale: 1,
					translate: {
						x: +(1024 / 2) / 129 * 10,
						y: +(420 / 2) / 189 * 10
					}
				}
			},
			units: {
				translate: '%'
			}
		}, {
			easing: 'linear'
		});


	});

	// How long to wait after intro before progressing to the next screen (in milliseconds).
	var WAIT_TIME = 2 * 1000;

	// Wait X seconds after intro has finished before progressing to the next screen
	screen.on('introEnd', function()
	{
		setTimeout(function()
		{
			$scope.begin(); 

		}, WAIT_TIME);

		Analytics.start('Tunnel Explorer');
	});
	
	// The next screen is the define screen
	$scope.begin = function()
	{
		manager.transition('level5_define');
	};
	
}]);